import React from 'react';
import GlobeIcon from '@dev-togetherprice/icons.globe';
import GroupIcon from '@dev-togetherprice/icons.group';
import HelpIcon from '@dev-togetherprice/icons.help';
import LayersIcon from '@dev-togetherprice/icons.layers';
import NavList from '@dev-togetherprice/components.nav-list';
import { makeStyles } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import en from '../../i18n/en.json';
import es from '../../i18n/es.json';
import it from '../../i18n/it.json';
import pt from '../../i18n/pt.json';
import useRegisteredTranslation from '@dev-togetherprice/hooks.use-register-translation';
const TRANSLATIONS = { en, es, it, pt };
const useStyles = makeStyles((theme) => ({
    itemWrapper: {
        borderTopLeftRadius: theme.spacing(2),
        borderBottomLeftRadius: theme.spacing(2),
        borderBottomRightRadius: ({ collapsed }) => {
            if (!collapsed)
                return 0;
            return theme.spacing(2);
        },
        borderTopRightRadius: ({ collapsed }) => {
            if (!collapsed)
                return 0;
            return theme.spacing(2);
        },
    },
    links: {
        marginTop: theme.spacing(9),
        paddingLeft: ({ collapsed }) => {
            if (!collapsed)
                return theme.spacing(5);
            return theme.spacing(4);
        },
        paddingRight: ({ collapsed }) => {
            if (!collapsed)
                return theme.spacing(0);
            return theme.spacing(4);
        },
    },
}));
const SidebarNavList = ({ navigateToUrl, activeTab, classes: newClasses = {}, collapsed, }) => {
    const { t } = useRegisteredTranslation('Sidebar', TRANSLATIONS);
    const baseClasses = useStyles({ collapsed });
    const allClasses = mergeClasses({
        newClasses,
        baseClasses,
        Component: SidebarNavList,
    });
    return (React.createElement(NavList, { navigateToUrl: navigateToUrl, links: [
            {
                icon: React.createElement(GlobeIcon, null),
                link: '/',
                name: t('network'),
                selected: activeTab === 'home',
            },
            {
                icon: React.createElement(LayersIcon, null),
                link: '/sharings/created',
                name: t('groups'),
                selected: activeTab === 'groups',
            },
            {
                icon: React.createElement(GroupIcon, null),
                link: '/social',
                name: t('social'),
                selected: activeTab === 'contacts',
            },
            {
                icon: React.createElement(HelpIcon, null),
                link: '/faqs',
                name: t('help'),
                selected: activeTab === 'help',
            },
        ], classes: {
            itemWrapper: allClasses.itemWrapper,
            list: allClasses.links,
        }, collapsed: collapsed }));
};
export default SidebarNavList;
